import { render, staticRenderFns } from "./CInput.vue?vue&type=template&id=d990a8a2&scoped=true&"
import script from "./CInput.vue?vue&type=script&lang=ts&"
export * from "./CInput.vue?vue&type=script&lang=ts&"
import style0 from "./CInput.vue?vue&type=style&index=0&id=d990a8a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d990a8a2",
  null
  
)

export default component.exports